"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_BONUS_COEFFICIENT = 1;
const MIN_ODD_COUNT = 2;
const MIN_EXPRESS_COEFFICIENT = 2.5;
const MIN_COEFFICIENT_VALUE_THRESHOLD = 1.3;
const MIN_ODD_COUNT_FOR_HIGH_COEFFICIENT = 10;
function getBounusForLowCoefficient(odds) {
    if (odds.length > 9) {
        return 1.1;
    }
    else {
        return 1 + 0.01 * odds.length;
    }
}
function getBounusForHighCoefficient(odds) {
    if (odds.length > 19) {
        return 2;
    }
    else {
        switch (odds.length) {
            case 11:
                return 1.15;
            case 12:
                return 1.2;
            case 13:
                return 1.3;
            case 14:
                return 1.4;
            case 15:
                return 1.5;
            case 16:
                return 1.6;
            case 17:
                return 1.7;
            case 18:
                return 1.8;
            case 19:
                return 1.9;
            default:
                return 2;
        }
    }
}
function calculateBonusOnExpress(odds) {
    const expressCoefficient = odds.reduce((acc, cur) => acc * cur, 1);
    if (odds.length < MIN_ODD_COUNT ||
        expressCoefficient < MIN_EXPRESS_COEFFICIENT) {
        return DEFAULT_BONUS_COEFFICIENT;
    }
    const oddsOverOrEqualCoef = odds.filter((odd) => odd >= MIN_COEFFICIENT_VALUE_THRESHOLD);
    if (oddsOverOrEqualCoef.length > MIN_ODD_COUNT_FOR_HIGH_COEFFICIENT) {
        return getBounusForHighCoefficient(oddsOverOrEqualCoef);
    }
    else {
        return getBounusForLowCoefficient(odds);
    }
}
exports.default = calculateBonusOnExpress;
//# sourceMappingURL=bonusOnExpress.js.map